import {forwardRef} from 'react'
import Svg, {Path} from 'react-native-svg'

import {type Props, useCommonSVGProps} from '#/components/icons/common'

/**
 * A book with a plus cut through it, its spine showing beside the cover.
 *
 * **This is a stand-in.** The capsule's *Add a capsule* mark is artwork that was
 * drawn for it, and the book's is meant to be the same kind of thing — a mark
 * supplied for this card rather than one made here. Until that artwork arrives this
 * draws a parallel shape in the app's own vocabulary (a dark spine, a cover with the
 * plus knocked through it, the same `evenodd` knockout `AddCapsule` uses), so the
 * Flashbooks tab is not waiting on a picture to be usable.
 *
 * Swapping it is one file: the paths below are the whole of it, and nothing outside
 * refers to how they are drawn.
 */
export const AddFlashbook = forwardRef<Svg, Props>(
  function AddFlashbookImpl(props, ref) {
    const {fill, size, style, ...rest} = useCommonSVGProps(props)

    return (
      <Svg
        fill="none"
        {...rest}
        ref={ref}
        viewBox="0 0 24 24"
        width={size}
        height={size}
        style={[style]}>
        {/* The spine, a shade quieter than the cover it holds. */}
        <Path
          fill={fill}
          opacity={0.55}
          d="M4.5 6.5h3.2v11H4.5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2Z"
        />
        {/* The cover, with the plus as a hole: `evenodd` is what knocks it through. */}
        <Path
          fill={fill}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 3.5h10A3.5 3.5 0 0 1 20.5 7v10a3.5 3.5 0 0 1-3.5 3.5H7a3 3 0 0 1-3-3v-11a3 3 0 0 1 3-3Zm3.75 7.7h2.2V9a0.8 0.8 0 1 1 1.6 0v2.2h2.2a0.8 0.8 0 1 1 0 1.6h-2.2V15a0.8 0.8 0 1 1-1.6 0v-2.2h-2.2a0.8 0.8 0 1 1 0-1.6Z"
        />
      </Svg>
    )
  },
)
